module.exports = __webpack_public_path__ + "img/111.waiting_time_for_service.73e424bc.svg";